import React, { Component } from 'react'
import { connect } from "react-redux";
import lodash from 'lodash';
import { cloneDeep } from 'lodash'
import { log_error } from '../../helpers/helper-error';

import * as helper_family_tree from '../../helpers/helper-family-tree';

import FamilyTreePartner from './partner';

import ModalTwins from '../modal-twins';
import ModalAdopted from '../modal-adopted';
import ModalHalfSiblingsUnclesAunts from '../modal-half-siblings-uncles-aunts';
import ModalHalfSiblingsTwinsCheck from '../modal-half-siblings-twins-check';

import ButtonAddEdit from '../button-add-edit';
import ModalPartnerDetails from '../modal-partner-details';
import ModalConfirmDelete from '../modal-confirm-delete';

import helpers from '../../helpers';
import family_api from '../../api/family-api'
import ErrorSummary from '../error-summary';
import * as model from '../../model-states/m-family-tree';
import * as patient_actions from '../../store/patient/actions';

class FamilyTreeUncleAunt extends Component {

  constructor(props) {
    super(props);
    this.state = {

      errorMessages: [],
      loading: false,

      collapsed: true,
      uncleAuntRkey: null,
      partners: null,
      openModalPartnerCount: false,
      modalPartnerCountHash: new Date().getTime(),

      openModalAdopted: false,
      modalAdoptedHash: new Date().getTime(),

      openModalHalfSiblings: false,
      modalHalfSiblingsHash: new Date().getTime(),

      openModalPartnerDetail: false,
      modalPartnerDetailHash: new Date().getTime(),

      openModalConfirmDelete: false,
      modalConfirmDeleteHash: new Date().getTime(),

      openModalHalfSiblingsTwinsCheck: false,
      modalHalfSiblingsTwinsCheckHash: new Date().getTime(),
    };

    this.updateFirstName = lodash.debounce(this.updateFirstName, 250)

  }

  async componentDidMount() {
    if ('collapsed' in this.props) this.setState({ collapsed: this.props.collapsed });
    this.setState({ uncleAuntRkey: this.props.uncle_aunt.rkey });

    // await this.populatePartnersFromAPI()
  }

  componentDidUpdate(prevProps) {
    this.loadPartnersFromRedux();
  }

  loadPartnersFromRedux() {
    if (this.state.uncleAuntRkey === null) return;

    if (!(this.state.uncleAuntRkey in this.props.patient.partners)) return;

    let partners = this.props.patient.partners[this.state.uncleAuntRkey];

    for(var partner of partners) {
      let relKey = partner.rkey
      if(relKey.includes('-fake')) partners.pop(partner)
    }
  
    if (!lodash.isEqual(this.state.partners, partners)) {
      this.setState({ partners });
    }
  }

  // async populatePartnersFromAPI() {
  //   try {
  //     let spouse_id = this.props.uncle_aunt.id
  //     if(spouse_id == null) return

  //     // Clear redux before repopulating
  //     this.props.dispatch(patient_actions.delete_partner({ownerRkey: this.props.uncle_aunt.rkey}))

  //     // Fetch Parter from API
  //     let partners = await family_api.get_member_memberid_partners(spouse_id)
  //     for(var partner of partners) {
  //       var partner_from_model = model.createPartner()
  //       var partner_data = Object.assign({}, partner_from_model, partner)

  //       // Save to Redux
  //       // partner_data.rkey = 'member_' + partner_data.id
  //       helper_family_tree.savePartnerToRedux(this.props.dispatch, this.props.uncle_aunt.rkey, partner_data)
  //       helper_family_tree.saveProfileToRedux(this.props.dispatch, partner_data)
  //     }
  //   } catch (error) {
  //     helpers.logger(error)
  //   }
  // }

  onCollapseClick(e) {
    this.setState({ collapsed: !this.state.collapsed });
    this.clearSelection();
  }

  clearSelection() {
    if (window.getSelection) { window.getSelection().removeAllRanges(); }
    else if (document.selection) { document.selection.empty(); }
  }

  onClickOpenModalPartnerCount() {
    this.setState({
      openModalPartnerCount: true,
      modalPartnerCountHash: new Date().getTime()
    });
  }

  async onChangeName(first_name) {
    try {
      let profile = { rkey: this.props.uncle_aunt.rkey, first_name }
      helper_family_tree.saveProfileToRedux(this.props.dispatch, profile)
      helper_family_tree.saveUncleAuntDetailToRedux(this.props.dispatch, this.props.parent_side, profile)
      this.updateFirstName(first_name);
    } catch (error) {
      log_error(this.constructor.name, error);
    }
  }

  async updateFirstName(first_name) {
    try {
      this.setState({errorMessages: []})

      let member = this.props.uncle_aunt
      await family_api.patch_member_memberid(member.id, {
        first_name
      })

    } catch (error) {
      this.setState({errorMessages: [error.message]})
    }
  }

  onClickOpenAdopted() {
    this.setState({
      openModalAdopted: true,
      modalAdoptedHash: new Date().getTime()
    });
  }

  onClickOpenHalfSibling() {
    this.setState({
      openModalHalfSiblings: true,
      modalHalfSiblingsHash: new Date().getTime(),
    });
  }

  onClickOpenModalHalfSiblingsTwinsCheck() {
    this.setState({
      openModalHalfSiblingsTwinsCheck: true,
      modalHalfSiblingsTwinsCheckHash: new Date().getTime()
    });
  }

  hasPartners() {
    try {
      return this.state.partners.length > 0;
    } catch (err) {
      return false;
    }
  }

  hasSiblings() {
    return this.props.patient.uncles_aunts[this.props.parent_side].length > 0;
  }

  onClickOpenModalConfirmDelete() {
    this.setState({
      openModalConfirmDelete: true,
      modalConfirmDeleteHash: new Date().getTime()
    });
  }

  async onClickDelete() {

    try {

      this.setState({errorMessages: [], loading: true})

      let leftover_id = null

      // Delete twins from API
      if(this.props.uncle_aunt.twin_id) {
        let {mother, father} = await family_api.get_member_memberid_parents(this.props.uncle_aunt.id);
        let twin_set = await family_api.get_twin(father.id, mother.id);
        for(let set of twin_set) {
          if(set.twin_id === this.props.uncle_aunt.twin_id) {
            let twin_length = set.members.length;
            if(twin_length === 2) {
              await family_api.delete_twin_set(set.twin_id);
              for(let member of set.members) {
                if(member.id !== this.props.uncle_aunt.id) leftover_id = member.id;
              }
            }
          }
        }
      }

      // Handle leftover twins from Redux and Local State
      if(leftover_id) {
        let twin_fix = {twin_id: null, twin_set: null, twin_type: null};
        let parent = (this.props.parent_side === 'paternal') ? this.props.patient.patient.father : this.props.patient.patient.mother
        if(parent.id === leftover_id) { // change this to parent check
          // fix parent, save to redux
          let patient = Object.assign({}, cloneDeep(parent), twin_fix)
          helper_family_tree.saveProfileToRedux(this.props.dispatch, patient)
        } else {
          for(let uncle_aunt of this.props.patient.uncles_aunts[this.props.parent_side]) {
            if(uncle_aunt.id === leftover_id) {
              // fix sibling, save to redux
              let patient = Object.assign({}, cloneDeep(uncle_aunt), twin_fix)
              helper_family_tree.saveUncleAuntDetailToRedux(this.props.dispatch, this.props.parent_side, patient)
              helper_family_tree.saveProfileToRedux(this.props.dispatch, patient)
            }
          }
        }
      }

      await this.props.deleteMember(this.props.uncle_aunt)

      helper_family_tree.deleteUncleAunt(this.props.patient,
        this.props.dispatch,
        this.props.parent_side,
        this.props.uncle_aunt);

      this.setState({ openModalConfirmDelete: false })

    } catch (error) {
      helpers.logger(error)
      this.setState({errorMessages: [error.message]})
    } finally {
      this.setState({loading: false})
    }

  }

  onClickOpenModalPartnerDetail() {
    this.setState({
      openModalPartnerDetail: true,
      modalPartnerDetailHash: new Date().getTime()
    });
  }

   async onClickModalAdoptedSave(data) {
    helper_family_tree.saveProfileToRedux(this.props.dispatch, data)
  }

  isHalfSibling() {
    let uncle_aunt = this.props.uncle_aunt;
    return uncle_aunt.half;
  }

  getPartnersCount() {
    if(this.state.partners) return this.state.partners.length

    return 0
  }

  getFirstName() {

    let profile = this.getProfile();
    if(profile == null) return null;

    return profile.first_name;
  }

  getProfile() {
    return helper_family_tree.getProfileFromRedux(this.props.patient, this.props.uncle_aunt.rkey)
  }

  getIsAdopted() {
    let profile = this.getProfile();
    if(profile == null) return false;
    return (profile.adopted_in || profile.adopted_out)
  }

  getProfileById(member_id) {
    let rkey = `apimem-${member_id}`;
    return cloneDeep(this.props.patient.profile[rkey]);
  }

  isTwin() {
    let profile = this.getProfile();
    if(profile == null) return false;
    return (profile.twin_id !== null );
  }

  async handleFixTwins() {
    let twins = await family_api.get_twin(
      this.props.fatherId,
      this.props.motherId
    );

    let selected_person = this.getProfile();
    let data = await family_api.delete_twin_set(selected_person.twin_id);

    for(let set of twins) {
      if(set.twin_id === selected_person.twin_id) {
        for(let twin of set.members) {
          const twinProfile = this.getProfileById(twin.id);
          if(twinProfile) {
            await this.clearTwinStatus(twinProfile);
          }
        }
      }
    }
    this.setState({ openModalHalfSiblingsTwinsCheck: false });
  }

  async clearTwinStatus(profile) {
    Object.assign({}, profile, { twin_id: null, twin_set: null, twin_type: null });
    helper_family_tree.saveProfileToRedux(this.props.dispatch, profile);
  }

  render() {
    return (
      <React.Fragment>

        <tr>
          <td>

            {this.getPartnersCount() > 0 &&
              <a onClick={(e) => this.onCollapseClick(e)}>
                <i className={"fa fa-" + (this.state.collapsed ? "minus-square" : "plus-square")}></i>
              </a>
            }

            {this.state.openModalConfirmDelete &&
              <ModalConfirmDelete
                loading={this.state.loading}
                errorMessages={this.state.errorMessages}
                isOpen={this.state.openModalConfirmDelete}
                onCancel={() => this.setState({ openModalConfirmDelete: false })}
                onOk={() => this.onClickDelete()}
              />
            }

            {this.state.openModalPartnerDetail &&
              <ModalPartnerDetails
                key={this.state.modalPartnerDetailHash}
                ownerRkey={this.state.uncleAuntRkey}
                owner={this.props.uncle_aunt}
                parent_side={this.props.parent_side}
                isOpen={this.state.openModalPartnerDetail}
                onClose={() => this.setState({ openModalPartnerDetail: false })}
                onClickSave={(partner_count) => {
                  this.setState({ openModalPartnerDetail: false })
                }}
              />
            }

            {this.state.openModalAdopted &&
              <ModalAdopted
                key={this.state.modalAdoptedHash}
                isOpen={this.state.openModalAdopted}
                onClose={() => this.setState({ openModalAdopted: false })}
                onSave={(data) => this.onClickModalAdoptedSave(data)}
                label={this.props.label}
                adopted={this.getProfile()}
              />
            }

            { this.state.openModalHalfSiblings &&
              <ModalHalfSiblingsUnclesAunts
                isOpen={this.state.openModalHalfSiblings}
                onClose={() => this.setState({openModalHalfSiblings: false})}
                onTwins={() => this.onClickOpenModalHalfSiblingsTwinsCheck()}
                isTwin={this.isTwin()}
                label={ this.props.label }
                sibling={this.props.uncle_aunt}
                patient={this.props.patient}
                maleLabel="Brother"
                femaleLabel="Sister"
                gender={this.props.uncle_aunt.gender}
                parent_side={this.props.parent_side}
              />
            }

            {this.state.openModalHalfSiblingsTwinsCheck && (
              <ModalHalfSiblingsTwinsCheck
                isOpen={this.state.openModalHalfSiblingsTwinsCheck}
                onCancel={() => this.setState({ openModalHalfSiblingsTwinsCheck: false })}
                onOk={() => this.handleFixTwins()}
              />
            )}

          </td>
          <td>
              {this.props.label}

          </td>
          <td>
            <input
              onChange={(e) => this.onChangeName(e.target.value)}
              value={this.getFirstName()}
              type="text" className="inputreg form-control normal-input-text" />

            <ErrorSummary errorMessages={this.state.errorMessages} transparent={true}/>
          </td>

          <td>

            <ButtonAddEdit
              onClick={() => this.onClickOpenModalPartnerDetail()}
              type={this.hasPartners() ? 'edit' : 'add'}
            />

          </td>

          <td>

            { this.hasSiblings() &&
              <button
                onClick={() => this.props.onClickTwin(this.props.uncle_aunt.id)}
                className={"btn btn-xs table-btn-add btn-" + (this.isTwin() ? 'teal' : 'light')}>
                <i className="fa fa-pencil"></i> Edit</button>
            }

          </td>

          <td>
          <button
              onClick={() => this.onClickOpenAdopted()}
              className={"btn btn-xs table-btn-add btn-" + (this.getIsAdopted() ? 'teal' : 'light')}>
              <i className="fa fa-pencil"></i> Edit</button>
          </td>

          <td>

            {/* This is for ve2 */}
            {/* Temporarily hiding half sibling button (CLIN-1249) */}
            <button
              onClick={() => this.onClickOpenHalfSibling() }
              className={"btn btn-xs table-btn-add btn-" + (this.isHalfSibling() ? 'teal btn-tooltip' : 'light btn-tooltip')}>
              <i className="fa fa-pencil"></i> Edit</button>
          </td>
          <td>

            <a
              onClick={() => this.onClickOpenModalConfirmDelete()}
              class="btn table-btn-add btn-xs"><i class="fa fa-trash"></i></a>

          </td>

        </tr>

        {this.state.collapsed && this.state.partners &&
          this.state.partners.map((partner, index) => {
            return <FamilyTreePartner
              key={partner.rkey}
              ownerRkey={this.state.uncleAuntRkey}
              collapsed={true}
              level={0}
              extra_indent={1}
              label={'Partner #' + (index + 1)}
              partner={partner}
              owner={this.props.uncle_aunt}
              parent_side={this.props.parent_side}
              dispatch={this.props.dispatch}
              patient={this.props.patient}
              deleteMember={this.props.deleteMember}
            />
          })
        }

      </React.Fragment>
    );
  }
}

export default FamilyTreeUncleAunt;
